import { handleAction } from '../../utils/handleAction';
import {
  GET_CAMPAIGN, CLEAN_CAMPAIGN,
  DELETE_CAMPAIGN, GET_CAMPAIGN_BY_ID, UPDATE_CAMPAIGN
} from '../actions/types';

const initialState = {
  campaign: {},
  campaigns: null,
  isLoading: false
};
const campaignReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CAMPAIGN_BY_ID:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload }),
        success: (prevState) => ({
          ...prevState,
          campaign: payload.data
        }),
      });

    case GET_CAMPAIGN:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload }),
        success: (prevState) => ({
          ...prevState,
          campaigns: payload.data
        }),
      });
    case UPDATE_CAMPAIGN:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload }),
        success: (prevState) => ({
          ...prevState,
          campaign: payload.data
        }),
      });
    case DELETE_CAMPAIGN:
      return handleAction(state, action, {
        failure: (prevState) => ({ ...prevState, error: payload }),
        success: (prevState) => ({
          ...prevState,
          campaign: payload.data
        }),
      });
    case CLEAN_CAMPAIGN:
      return { ...state, campaign: {} };
    default:
      return state;
  }
};
export default campaignReducer;
